import React from "react";
import LogoDark from "../assets/images/LogoDark";

const LightModeLogo = () => {
    return (
        <div className="">
            <LogoDark />
        </div>
    );
};

export default LightModeLogo;
